/**
 * Blob ↔ bytes, without assuming `Blob.arrayBuffer()` exists. It is missing in
 * some older mobile browsers, and in jsdom, so the FileReader path is a real
 * fallback rather than defensive noise.
 */
export type Bytes = Uint8Array<ArrayBuffer>;

export async function blobToBytes(blob: Blob): Promise<Bytes> {
  if (typeof blob.arrayBuffer === 'function') {
    return new Uint8Array(await blob.arrayBuffer());
  }
  return new Promise<Bytes>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = () => reject(reader.error ?? new Error('Could not read the file.'));
    reader.readAsArrayBuffer(blob);
  });
}

export function bytesToBlob(bytes: Bytes, mime: string): Blob {
  return new Blob([bytes], { type: mime });
}
